module.exports = __webpack_public_path__ + "static/media/calendar.3392159b.svg";